// .........Imports.............
import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

// .............Icons import............
import editIcon from "../../../assets/images/register/edit.png";
import validIcon from "../../../assets/images/register/green_check.svg";
import indiaFlag from "../../../assets/images/register/india.svg";

// .............Action imports...........
import {
    clearLoginDataResponse,
    clearUserLoginSignupOtpResponse,
    clearUserAuthenticationResponse
} from "../../../../store/slices/Registration/CommonSlices";
import {gaEvent, gaLocationAndContentData} from "../../../utils/index";


// MobileInputLogin component handles the mobile input field for user login/signup
const MobileInputLogin = (props) => {
    // State variables
    const navigate = useNavigate()
    const { values, setFieldValue, errors, touched, handleBlur, locationData } = props;
    const mobileInputRef = useRef(null);
    const [focused, setFocused] = useState(false);
    // Effect hook to focus on the mobile input field if the form is in mobile editing state
    useEffect(() => {
      if (props.formCurrentState?.isMobileEditing) {
            setTimeout(() => {
                if (mobileInputRef.current) {
                    mobileInputRef.current.focus();
                }
            }, 10)
       } 
    }, [])
    useEffect(() => {
        function handleKeyUp(event) {
            if (event?.key === 'Enter') {
                if (!errors?.mobile) {
                    props.otpApiCall(values.mobile);
                }
            }
        }
        document.addEventListener("keyup", handleKeyUp);
        return (() => {
            document.removeEventListener("keyup", handleKeyUp);
          })
    }, [values, errors])

    // Handler to set the focused state and mark the field as touched
    const handleIsFocused = () => {
        setFocused(true)
        props.updateTouchedFields({ ...touched, [`${props.name}`]: true })
    }

    // Function to render the mobile input field with appropriate event handlers
    const renderMobileInput = (type) => {
        return (
            <input
                type="text"
                className="input_type_number"
                name="mobile"
                onBlur={(e) => {
                    handleBlur(e);
                    props.updateTouchedFields({ ...touched, [`${props.name}`]: true });
                }}
                maxLength={10}
                onChange={(e) => {
                    props.dispatch(clearUserAuthenticationResponse())
                    props.dispatch(clearUserLoginSignupOtpResponse())

                    // Get the current input value
                    const rawValue = e.target.value;
                    // Sanitize the input to allow only digits
                    const sanitizedValue = rawValue?.replace(/[^\d]/g, '');
                    // If the input length exceeds 10, prevent updating the value further
                    if (sanitizedValue?.length > 10) {
                    return;
                    }
                    setFieldValue("mobile", sanitizedValue);
                    if (sanitizedValue?.length == 10)
                        props.mobileAuthApiCall(sanitizedValue)
                }}
                value={values?.mobile}
                onFocus={handleIsFocused}
                inputMode="numeric"
                ref={type === "login" ? null : mobileInputRef}
            />
        );
    };

    // Function for GA events
    const GAEventsData = () => {
        gaEvent("otpchangemobilesignin", "login_signup", `${gaLocationAndContentData}`, "");
    }

    return (
        <div className={props.userAuthenticationErrors || (errors?.mobile && touched?.mobile) ? "careers_register_mobile_card invalid_field" : values?.mobile ? "careers_register_mobile_card white_bg" : "careers_register_mobile_card"}>
            {(focused || touched?.mobile || values?.mobile) && (<>
                <span className={"register_country_logo_margin"}
                >
                    <img src={indiaFlag} alt="indiaFlag" />
                </span>
                <span className="register_country_code">{"+91"}</span>
            </>)}
            <div className="careers_register_mobile_number">
                {props.usersLoginSignupOtp ?
                    <>
                        <input
                            type="text"
                            name="mobile"
                            className="input_type_number"
                            value={values?.mobile}
                            readOnly
                        />
                    </> : renderMobileInput("otpVerify")
                }
                <span className={values?.mobile ? 'floating_label_active' : (!focused && !touched?.mobile && !values?.mobile) ? 'floating_label_mobile' : 'floating_label'}>{"Mobile Number"}</span>
            </div>

            {
                props.otpVerifyScreen ?
                    <div
                        onClick={() => {
                            props.dispatch(clearUserLoginSignupOtpResponse())
                            props.dispatch(clearLoginDataResponse())
                            navigate(`/user/login${window.location.search}`)
                            GAEventsData();
                        }}
                        className="edit_card">
                        <img src={editIcon} alt="edit_icon" />
                        <span>Edit</span>
                    </div>
                    : props.usersAuthentication && !errors?.mobile && !props.usersLoginSignupOtpError &&
                    <img
                        src={validIcon}
                        alt="careers_register_checkIcon"
                        className="careers_register_valid_icon"
                    />
            }
            {/* To show error validation mesaage */}
            {
                errors?.mobile && touched?.mobile && (
                    <div className="invalid_card">
                        <span className="invalid_card_text">{errors?.mobile}</span>
                    </div>
                )
            }
            {/* To show the contact support message in case of OTP limit exceed or user gets blocked */}
            {
                (props.userAuthenticationErrors?.authorization == false || props.usersLoginSignupOtpError?.block_user_case == "user_restricted" 
                || props.usersLoginSignupOtpError?.block_user_case == "otp_exceed") && !errors?.mobile &&
                    <div className="invalid_card">
                        <span className="invalid_card_text">Mobile error, <a href="https://www.careers360.com/grievance-redressal" target="_blank" rel="noopener noreferrer" className="contact_support_text">contact support</a></span>
                    </div>
            }
        </div>
    );
};
const mapStateToProps = (state) => {
    return {
        userIps: state.usersCommonData?.userIp,
        countryCodeData: state.usersCommonData?.countryCode,
        userAuthenticationErrors: state.usersCommonData?.userAuthenticationError,
        userAuthenticatedForOtp: state.usersCommonData?.userAuthenticatedForOtp,
        usersLoginSignupOtp: state.usersCommonData?.userLoginSignupOtp,
        usersAuthentication: state.usersCommonData?.userAuthentication,
        usersLoginSignupOtpError: state.usersCommonData?.userLoginSignupOtpError,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MobileInputLogin);


